// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Buefy from 'buefy'
import App from './App'
import router from './router'
import store from './store'
import TextHelper from '@/helpers/TextHelper'

import '@/assets/scss/bulma.scss'
import 'buefy/dist/buefy.css'
import '@/assets/scss/base.scss'

Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(TextHelper)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js